import { Hero } from "@/components/home/Hero";
import { Acknowledgement } from "@/components/home/Acknowledgement";
import { Bento } from "@/components/home/Bento";
import { ProgrammesPreview } from "@/components/home/ProgrammesPreview";
import { DonateCallout } from "@/components/home/DonateCallout";
import { Marquee } from "@/components/site/Marquee";
import { SafePlaceTeaser } from "@/components/home/SafePlaceTeaser";

export default function Home() {
  return (
    <main>
      <Hero />
      <Acknowledgement />
      <Bento />
      <Marquee className="bg-sand text-ink" />
      <ProgrammesPreview />
      <SafePlaceTeaser />
      <DonateCallout />
    </main>
  );
}
